import { createEventEmitter } from './EventEmitter';

it('check arguments passed to subscriber', () => {
  const emitter = createEventEmitter();
  let receivedArgs;
  emitter.subscribe((args) => {
    receivedArgs = args;
  });
  emitter.emit('test');
  expect(receivedArgs).toEqual('test');
});

it('emit without subscriber', () => {
  const emitter = createEventEmitter();
  emitter.emit('test');
});

it('check arguments passed to multiple subscribers', () => {
  const emitter = createEventEmitter();
  let receivedArgs1; let
    receivedArgs2;
  emitter.subscribe((args) => {
    receivedArgs1 = args;
  });
  emitter.subscribe((args) => {
    receivedArgs2 = args;
  });
  emitter.emit('test');
  expect(receivedArgs1).toEqual('test');
  expect(receivedArgs2).toEqual('test');
});

it('remove one subscriber', () => {
  const emitter = createEventEmitter();
  let receivedArgs1; let
    receivedArgs2;
  const unsubscribe1 = emitter.subscribe((args) => {
    receivedArgs1 = args;
  });
  emitter.subscribe((args) => {
    receivedArgs2 = args;
  });
  emitter.emit('test');
  expect(receivedArgs1).toEqual('test');
  expect(receivedArgs2).toEqual('test');

  unsubscribe1();

  emitter.emit('removed');
  expect(receivedArgs1).toEqual('test');
  expect(receivedArgs2).toEqual('removed');
});

it('remove both subscribers', () => {
  const emitter = createEventEmitter();
  let receivedArgs1; let
    receivedArgs2;
  const unsubscribe1 = emitter.subscribe((args) => {
    receivedArgs1 = args;
  });
  const unsubscribe2 = emitter.subscribe((args) => {
    receivedArgs2 = args;
  });
  emitter.emit('test');
  expect(receivedArgs1).toEqual('test');
  expect(receivedArgs2).toEqual('test');

  unsubscribe1();
  unsubscribe2();

  emitter.emit('removed');
  expect(receivedArgs1).toEqual('test');
  expect(receivedArgs2).toEqual('test');
});

it('multiple nested subscribers - nested subscribers are not active on first emmit', () => {
  const emitter = createEventEmitter();
  let receivedArgs1; let receivedArgs2; let
    receivedArgs3;
  emitter.subscribe((args1) => {
    receivedArgs1 = args1;
    emitter.subscribe((args2) => {
      receivedArgs2 = args2;
      emitter.subscribe((args3) => {
        receivedArgs3 = args3;
      });
    });
  });

  emitter.emit('test');
  expect(receivedArgs1).toEqual('test');
  expect(receivedArgs2).toEqual(undefined);
  expect(receivedArgs3).toEqual(undefined);
});

it('check unsubscribe within listener', () => {
  const emitter = createEventEmitter();
  let receivedArgs1; let
    receivedArgs2;
  const unsubscribe1 = emitter.subscribe((args) => {
    receivedArgs1 = args;
  });
  emitter.subscribe((args) => {
    receivedArgs2 = args;
    unsubscribe1();
  });
  emitter.emit('test');
  expect(receivedArgs1).toEqual('test');
  expect(receivedArgs2).toEqual('test');

  emitter.emit('second time');
  expect(receivedArgs1).toEqual('test');
  expect(receivedArgs2).toEqual('second time');
});

it('reject subscriber that is not a function', () => {
  const emitter = createEventEmitter();
  expect(() => emitter.subscribe({})).toThrow('Subscriber must provide a function');
});
